export class DeviceParamOptV5 {

    public paramA: number;
    public paramB: number;
    public paramC: number;
    public wp: number;
    public type: string;

}
